
  import {Component, Prop, Watch, Vue} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  
  @Component({
    name: "FormInsumo"
  })
  export default class FormInsumo extends Vue {
    @Prop() dialog!: boolean
    @Prop() insumo_selected!: object
    @Prop() swEditar!: boolean

    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
  
    insumo = {
      id: null,
      nombre: '',
      descripcion: '',
      costo: 0,
      precio_venta: 0,
      stock_actual: 0,
      proveedor: '',
      categoria_id: null,
      tratamiento_id: null
    };
    valid = true;
    
   
    mounted(){
      console.log(this.swEditar)
      setTimeout(this.cargarDatos,1500);
    }
    
    close(){
      this.limpiar();
      this.$emit("close");
    }
    guardar(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Lene todos los campos obligatorios (*)`)
          return;
        }
      if(!this.swEditar){
        Alert.confirm(`Se registrará el insumo ${this.insumo.nombre} `, 'Registrar nuevo insumo?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.registrarInsumo(this.insumo).then(response =>{
              this.limpiar()
              this.$emit('close')
              this.$emit('listar')
            })
            
          }
        })
      }else {
        Alert.confirm(`Se realizará la modificacion del insumo`, 'Modificar insumo?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.updateInsumo(this.insumo)
            this.limpiar()
            this.$emit('close')
            this.$emit('listar')
          }
        })
      }
      
    }
    cargarDatos(){
      console.log(this.swEditar)
      if(this.swEditar == false){
        this.limpiar()
        return
      }
      console.log('cargar')
      if( Object.entries(this.insumo_selected).length !== 0 && this.insumo_selected.constructor === Object){
        //this.swEditar = false;
        console.log('entra')
        this.insumo = {
          id: this.insumo_selected.id,
          nombre: this.insumo_selected.nombre,
          descripcion: this.insumo_selected.descripcion,
          costo: this.insumo_selected.costo,
          precio_venta: this.insumo_selected.precio_venta,
          stock_actual: this.insumo_selected.stock_actual,
          proveedor: this.insumo_selected.proveedor,
          categoria_id: this.insumo_selected.categoria_id,
          tratamiento_id: this.insumo_selected.tratamiento_id
  
        };
      }
    }
    limpiar(){
      this.insumo = {
        id: null,
        nombre: '',
        descripcion: '',
        costo: 0,
        precio_venta: 0,
        stock_actual: 0,
        proveedor: '',
        categoria_id: null,
        tratamiento_id: null
        
      };
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    
  }
  